// Export all affair-related services
export { RouteCalculationService } from './route-calculation.service'
export type {
  RouteInfo,
  HomeDepartureInfo,
  HomeReturnInfo,
  ProjectedReturnInfo,
  DailyDataCache,
  Coordinates,
  AffairRouteData,
} from './route-calculation.service'

export { InterventionIndicatorService } from './intervention-indicator.service'
export type {
  SlotIndicator,
  ConstrainedSlotCounts,
  SlotTravelInfo,
  AffairIndicatorData,
} from './intervention-indicator.service'

export { AvailabilityDataService } from './availability-data.service'
export type {
  EmptyDaySlot,
  TechnicianWithDistance,
} from './availability-data.service'

export { TechnicianSelectionService } from './technician-selection.service'
export type { AutoSelectionResult } from './technician-selection.service'
